"use client";

// Overview deal table — GET /api/admin/deals (first page, newest first).
// Rows map to the shared DealsTable view model; clicking one opens the drawer.

import { useState } from "react";
import { adminApi, type AdminDeal, type PageMeta } from "../lib/api";
import { toDealRow } from "../lib/adminMap";
import { useApi } from "../lib/useApi";
import DealsTable from "./DealsTable";
import DealDetail from "./DealDetail";

const LIMIT = 6;

export default function RecentDeals() {
  const [selected, setSelected] = useState<number | null>(null);

  const { data, loading, error, reload } = useApi<{ items: AdminDeal[]; meta: PageMeta }>(
    (signal) => adminApi.deals({ page: 1, limit: LIMIT }, signal),
    [],
    "Failed to load deals.",
  );

  const deals = data?.items ?? [];
  const rows = deals.map(toDealRow);
  // DealsTable keys rows by deal code — map back to the numeric id for the API.
  const idByCode = new Map(deals.map((d) => [d.code || String(d.id), d.id]));

  return (
    <>
      <DealsTable
        title="Recent Deals"
        rows={rows}
        loading={loading}
        error={error}
        onRetry={reload}
        emptyHint="Deals appear here as salespeople log customers."
        onRowClick={(row) => setSelected(idByCode.get(row.id) ?? null)}
        action={
          <span className="text-[12.5px] text-text-faint">
            {data?.meta.total !== undefined ? `${data.meta.total} total` : `${rows.length} shown`}
          </span>
        }
      />
      <DealDetail dealId={selected} onClose={() => setSelected(null)} />
    </>
  );
}
